import { render, staticRenderFns } from "./AccountShop.vue?vue&type=template&id=54651e87&scoped=true&"
import script from "./AccountShop.vue?vue&type=script&lang=ts&"
export * from "./AccountShop.vue?vue&type=script&lang=ts&"
import style0 from "./AccountShop.vue?vue&type=style&index=0&id=54651e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54651e87",
  null
  
)

export default component.exports